// extracted by mini-css-extract-plugin
export var fadeInAnimation = "LinkTiles-module--fadeInAnimation--1ab0f";
export var tile = "LinkTiles-module--tile--d75fe";
export var tileLink = "LinkTiles-module--tileLink--2a996";
export var tilesWrapper = "LinkTiles-module--tilesWrapper--06436";